import styled from "styled-components";
import { ConsultaPadrao } from "../../../components/ConsultaPadrao";
import { model_colaborador, model_colaborador_classificacao, model_colaborador_status, options_cor_etinia, options_deficiente, options_escolaridade, options_estadocivil, options_sim_nao } from "../../../models";
import { Col, Row } from "react-bootstrap";
import { ageCalculator, ButtonCopy, formatDataCompare, formatDate, formatMonetary, getLocalStorage, isMobileDevice, setLocalStorage, toastError } from "../../../commons/utils";
import { ColaboradorInvalidacoes } from "../ColaboradorInvalidacoes";
import { useEffect, useRef, useState } from "react";
import { LabelDataTable } from "../../../components/LabelDataTable";
import { ButtonWhatsApp } from "../../../components/ButtonWhatsApp";
import ColaboradorPdf, { ColaboradorPdfHandler } from "../ColaboradorPdf";
import { useAuth } from "../../../contexts/AuthProvider/useAuth";
import { confirmDesistencia, deleteFileColaborador, getFiles, updateStatus, uploadFileColaborador } from "./utils";
import { Gallery, GalleryHandler } from "../../Gallery";
import { ListX, Paperclip, Plus, Printer, Redo, Undo, X } from "lucide-react";
import { Privilegio } from "../../../contexts/AuthProvider/types";
import { DynamicIcon } from "lucide-react/dynamic";
import { ExTooltip } from "../../../components/Tooltip";
import { ExButton } from "../../../components/ExButton";
import { ColaboradorClassificacaoRef, ColaboradorSelecionaClassificacao } from "../ColaboradorSelecionaClassificacao";

const ContainerDetail = styled.div`
    font-size: 12px;
    padding: 0 1rem;
    background-color: rgba(0, 0, 0, .075);
    border-radius: 8px;
`
const LabelDetail = styled.div`
    background-color: rgba(0, 0, 0, .3);
    border-radius: 4px;
    margin: 5px 1rem 8px 0px;
    padding: 4px 10px;
`
const RowDetail = styled.div`
    margin-top: 2px;
    padding-left: 5px;
    margin-bottom: 2px;
    user-select: none;
`;

const DivCaption = styled.div`
    display: inline-block;
    margin-right: 4px;
`

const DivValue = styled.div`
    display: inline-block;
    user-select: text;
`

export const details = (row: any) => {
    function ViewDados(label: string, value: any) {
        return (
            <RowDetail>
                <DivCaption>{label}</DivCaption>
                <DivValue>{value} </DivValue>
                <ButtonCopy text={value} />
            </RowDetail>
        )
    }

    function getLabelByValue(options: any, value: any) {
        const option = options.find((option: any) => option.value === value);
        return option ? option.label : "";
    }

    return (
        <ContainerDetail>
            <Row>
                <Col className={"p-0"}>
                    <LabelDetail>DADOS PESSOAIS</LabelDetail>
                    {ViewDados('Orgão Expedidor RG:', row.colrgorgaoexpedicao)}
                    {ViewDados('Data Expedição RG:', formatDate(row.colrgdataexpedicao))}
                    {ViewDados('Município de Nascimento:', row.munnomenascimento)}
                    {ViewDados('UF de Nascimento:', row.munufnascimento)}
                    {ViewDados('Nascimento:', `${formatDate(row.colnascimento)} (${ageCalculator(row.colnascimento)} anos)`)}
                    {ViewDados('Sexo:', row.colsexo === 0 ? 'Masculino' : row.colsexo === 1 ? 'Feminino' : 'Outro')}
                    {ViewDados('E-mail:', row.colemail)}
                    {ViewDados('Dependentes:', row.coldependentes)}
                    {ViewDados('Cor/Etnia:', getLabelByValue(options_cor_etinia, row.colcoretinia))}
                    {ViewDados('Estado Civil:', getLabelByValue(options_estadocivil, row.colestadocivil))}
                    {ViewDados('Escolaridade:', getLabelByValue(options_escolaridade, row.colescolaridade))}
                    {ViewDados('Deficiência:', getLabelByValue(options_deficiente, row.coldeficiencia))}
                    {ViewDados('Outra Deficiência:', row.coloutradeficiencia)}
                    {ViewDados('Pai:', row.colnomepai)}
                    {ViewDados('Mãe:', row.colnomemae)}
                    {ViewDados('Cônjuge:', row.colnomeconjuge)}
                </Col>
                <Col className={"p-0"}>
                    <LabelDetail>ENDEREÇO</LabelDetail>
                    {ViewDados('CEP:', row.colcep)}
                    {ViewDados(
                        'Logradouro: ',
                        (row.collogradouro ?? '') + (row.collogradouronumero ? ' Nº ' + row.collogradouronumero : '')
                    )}
                    {ViewDados('Bairro:', row.colbairro)}
                    {ViewDados('Município:', row.munnome)}
                    {ViewDados('UF:', row.munuf)}
                </Col>
                <Col className={"p-0"}>
                    <LabelDetail>DADOS PROFISSIONAIS</LabelDetail>
                    {ViewDados('Salário Inicial:', formatMonetary(row.colsalarioinicial))}
                    {ViewDados('Sindicalizado:', getLabelByValue(options_sim_nao, row.colsindicalizado))}
                    {ViewDados('Contribuição Sindical:', getLabelByValue(options_sim_nao, row.colcontribuicaosindical))}
                    {ViewDados('Jornada de Trabalho:', row.jorntrabdescricao)}
                    {ViewDados('Conta Bancária:', (row.colcbagencia ? row.colcbagencia : '') + (row.colcbconta ? ' - ' + row.colcbconta : ''))}
                </Col>
            </Row>
        </ContainerDetail>
    );
};

const renderClassificacao = (e: any, refModal: ColaboradorClassificacaoRef) => {
    console.log(e.colclassicone, e.colclasscor)
    return (
        <ExTooltip title={e.colclassdescricao ? (e.colclassdescricao + (e.colclasshistobservacao ? ': ' + e.colclasshistobservacao : '')) : 'Adicionar classificação'}>
            <ExButton size='sm' color={e.colclasscor || 'transparent'} className='m-0 me-2 p-1' style={{ borderRadius: '6px' }} onClick={() => refModal.openModal(e.colid, e.colclassid)} >
                {e.colclassid ?
                    (e.colclassicone ?
                        <DynamicIcon name={e.colclassicone} color={'white'} />
                        :
                        <DynamicIcon name={'user-star'} color={'white'} />
                    ) :
                    <Plus />}
            </ExButton>
        </ExTooltip>
    )
}

export const Colaborador = () => {
    const auth = useAuth();

    const refinvalidacoes = useRef<any>();
    const refdatatable = useRef<any>();
    const iadmissaoref = useRef<any>();
    const fadmissaoref = useRef<any>();
    const statusref = useRef<any>();
    const classificacaoref = useRef<any>();
    const desistentesref = useRef<any>()
    const refColaboradorPdf = useRef<ColaboradorPdfHandler>(null);
    const refgallery = useRef<GalleryHandler>(null);
    const refModalClassificacao = useRef<ColaboradorClassificacaoRef>(null)

    const [showing, setShowing] = useState(false);
    const [apiFilter, setApiFilter] = useState('');
    const [viewAllGroups, setViewAllGroups] = useState(false)

    const [status, setStatus] = useState<any>();

    useEffect(() => {
        auth.get('/v1/colaboradorstatus')
            .then((response: any) => {
                const filteredData = response.data.filter((item: any) => item.colstatusativo === 1).sort((a: any, b: any) => a.colstatussequencia - b.colstatussequencia);

                const _status = filteredData.map((item: any) => ({
                    id: item.colstatusid,
                    title: item.colstatusdescricao,
                    color: item.colstatuscor,
                    value: item.colstatusid,
                    sequencia: item.colstatussequencia,
                    rejeitado: item.colstatusrejeicao
                }));

                setStatus(_status);
            })
            .catch((error: any) => {
                toastError(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FormatTelefoneWhatsApp = (num: string) => {
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <span>{num}</span>
                {num && <ButtonWhatsApp num={num} />}
            </div>
        );
    };

    const columns = [
        auth.usuconsultacolclass === 1 ? { field: 'colclassid', header: '', body: (e: any) => refModalClassificacao.current && renderClassificacao(e, refModalClassificacao.current) } : undefined,
        { field: 'colnome', header: 'Nome' },
        { field: 'grudescricaosuperior', header: 'Empresa', invisible: !viewAllGroups },
        { field: 'grudescricao', header: 'Grupo' },
        { field: 'colcpf', header: 'CPF' },
        { field: 'coldatacadastro', header: 'Cadastro', body: (e: any) => formatDate(e.coldatacadastro, true) },
        { field: 'coladmissao', header: 'Admissão', body: (e: any) => formatDate(e.coladmissao, true) },
        { field: 'cbodescricao', header: 'CBO (Cargo)', style: { width: window.innerWidth, whiteSpace: 'pre-wrap' } },
        { field: 'coltelefone', header: 'Telefone', body: (e: any) => FormatTelefoneWhatsApp(e.coltelefone) },
        { field: 'colstatusid', header: 'Status', body: (e: any) => { return LabelDataTable(e.colstatusdescricao, e.colstatuscor || '#e4e6e8') }, style: { minWidth: '200px' } },
        { field: 'functions', style: { minWidth: '2rem', width: '2rem' } }
    ].filter(e => e)

    refdatatable.current?.setColumnsInvisibles(columns);

    function getFunctions(row: any) {
        const sequencias = status?.map((item: any) => item.sequencia) || [];

        const menorSequencia = Math.min(...sequencias);
        const maiorSequencia = Math.max(...sequencias);

        return row.coldesid ? [{ click: () => confirmDesistencia(auth, row.coldesid, row.colid).then(onSuccess), icon: <X size={20} />, color: 'red', label: 'Desistente', disabled: auth.privilegio === Privilegio.Normal }] :
            [
                { click: () => refinvalidacoes.current.openModal(row), icon: <ListX size={20} />, color: '#da5a33', privilegioMinimo: Privilegio.Gestao },
                { click: () => updateStatus(auth, status, row, false).then(onSuccess), icon: <Undo size={20} />, disabled: row.colstatussequencia === menorSequencia || row.colstatusrejeicao === 1, privilegioMinimo: Privilegio.Gestao },
                { click: () => updateStatus(auth, status, row, true).then(onSuccess), icon: <Redo size={20} />, disabled: row.colstatussequencia === maiorSequencia || row.colstatusrejeicao === 1, privilegioMinimo: Privilegio.Gestao },
                { click: () => refColaboradorPdf.current?.generatePDF(row.colid), icon: <Printer size={20} /> },
                {
                    click: async () => {
                        const files = await getFiles(auth, row.colid);
                        refgallery.current?.openModal(files, row.colnome, row.colid, true);
                    },

                    icon: <Paperclip size={20} />
                }
            ].filter(e => (e.privilegioMinimo ?? 0) <= (auth.privilegio ?? 1))
    }

    function onSuccess() {
        refdatatable.current.refresh();
    }

    function filterData(data: any, iAdmissao: any, fAdmissao: any, status: any, desistentes: any, classificacoes: any) {
        let _data: any = [];

        _data = data;

        if (iAdmissao)
            _data = _data.filter((item: any) => formatDataCompare(item.coladmissao) >= iAdmissao);

        if (fAdmissao)
            _data = _data.filter((item: any) => formatDataCompare(item.coladmissao) <= fAdmissao);

        if (status && (status.length > 0)) {
            const _status = new Set(status.map((item: any) => item.label));

            _data = _data.filter((item: any) => _status.has(item.colstatusdescricao));
        }

        if (classificacoes && classificacoes.length > 0) {
            const _class = new Set(classificacoes.map((item: any) => item.value));
            _data = _data.filter((item: any) => _class.has(item.colclassid));
        }

        if (!desistentes)
            _data = _data.filter((item: any) => !item.coldesid)

        setLocalStorage('i_admissao_colaboradores', iAdmissao ?? null);
        setLocalStorage('f_admissao_colaboradores', fAdmissao ?? null);
        setLocalStorage('status_colaboradores', status ?? null);
        setLocalStorage('desistentes_colaboradores', desistentes ?? null);

        refdatatable.current.setCustomData(_data);
    }

    async function changeAdmissaoInicial(value: any, data: any) {
        filterData(data, value, fadmissaoref.current.getValue(), statusref.current.getValue(), desistentesref.current.getValue(), classificacaoref.current?.getValue())
    }

    async function changeAdmissaoFinal(value: any, data: any) {
        filterData(data, iadmissaoref.current.getValue(), value, statusref.current.getValue(), desistentesref.current.getValue(), classificacaoref.current?.getValue())
    }

    async function changeStatus(selecteds: any, data: any) {
        filterData(data, iadmissaoref.current.getValue(), fadmissaoref.current.getValue(), selecteds, desistentesref.current.getValue(), classificacaoref.current?.getValue())
    }

    async function changeClassificacao(selecteds: any, data: any) {
        filterData(data, iadmissaoref.current.getValue(), fadmissaoref.current.getValue(), statusref.current.getValue(), desistentesref.current.getValue(), selecteds)
    }

    async function changeDesistentes(value: any, data: any) {
        filterData(data, iadmissaoref.current.getValue(), fadmissaoref.current.getValue(), statusref.current.getValue(), value, classificacaoref.current?.getValue())
    }

    function afterRefresDataTable(data: any) {
        var iadmissao;
        var fadmissao;
        var status;
        var desistentes;
        var classificacoes;

        if (!showing) {
            iadmissao = getLocalStorage('i_admissao_colaboradores');
            fadmissao = getLocalStorage('f_admissao_colaboradores');
            status = getLocalStorage('status_colaboradores');
            desistentes = getLocalStorage('desistentes_colaboradores');
            classificacoes = getLocalStorage('classificacao_colaboradores');

            filterData(data, iadmissao, fadmissao, status, desistentes, classificacoes);

            setShowing(true);
        } else
            filterData(data, iadmissaoref.current?.getValue(), fadmissaoref.current?.getValue(), statusref.current?.getValue(), desistentesref.current?.getValue(), classificacaoref.current?.getValue())
    }

    const filters = [
        {
            ref: iadmissaoref, md: 2, id: 'iAdmissao', label: 'Admissão Inicial', type: 'date',
            onChange: changeAdmissaoInicial, defaultValue: getLocalStorage('i_admissao_colaboradores')
        },
        {
            ref: fadmissaoref, md: 2, id: 'fAdmissao', label: 'Admissão Final', type: 'date',
            onChange: changeAdmissaoFinal, defaultValue: getLocalStorage('f_admissao_colaboradores')
        },
        {
            ref: statusref, md: auth.usuconsultacolclass === 1 ? 3 : 5, id: 'status', label: 'Status', type: 'select', model: model_colaborador_status, isMulti: true,
            onChange: changeStatus, defaultValue: getLocalStorage('status_colaboradores')
        },
        auth.usuconsultacolclass === 1 ? {
            ref: classificacaoref, md: 2, id: 'classificacao', label: 'Classificação', type: 'select', model: model_colaborador_classificacao, isMulti: true,
            onChange: changeClassificacao, defaultValue: getLocalStorage('classificacao_colaboradores')
        } : null,
        {
            md: 2, id: 'viewallgroups', label: 'Visualizar todas as Empresas', type: 'check', customStyle: { marginTop: isMobileDevice() ? 0 : '29px' },
            onClick: (e: any) => {
                setApiFilter('?allgroups=' + (e.target.checked ? '1' : '0'));
                setViewAllGroups(e.target.checked)
                refdatatable.current.refresh('?allgroups=' + (e.target.checked ? '1' : '0'));
            }
        },
        {
            ref: desistentesref, md: 1, id: 'desistentes', label: 'Desistentes', type: 'check', customStyle: { marginTop: isMobileDevice() ? 0 : '29px' },
            onChange: changeDesistentes, defaultValue: getLocalStorage('desistentes_colaboradores'),
        }
    ].filter(e => e)

    return (
        <>
            <ColaboradorSelecionaClassificacao ref={refModalClassificacao} onSuccess={() => refdatatable?.current.refresh()} />
            <ColaboradorPdf ref={refColaboradorPdf} />
            <ColaboradorInvalidacoes
                ref={refinvalidacoes}
                onSuccess={onSuccess}
            />
            <ConsultaPadrao
                ref={refdatatable}
                model={model_colaborador}
                columns={columns}
                details={details}
                functions={getFunctions} sortField='coldatacadastro' sortOrder={-1}
                inputfilters={filters}
                onAfterRefresh={afterRefresDataTable}
                apifilter={apiFilter}
            />
            <Gallery ref={refgallery} onUploadFile={(colid, file) => uploadFileColaborador(auth, colid, file)} onRemoveFile={(movid, file) => deleteFileColaborador(auth, movid, file)} />
        </>
    )
} 